"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.weightClass = void 0;
exports.weightClass = [
    { id: 1, class: 1, weight: [1, 6000], name: '< 6,000 lbs. (1)' },
    { id: 2, class: 2, weight: [6001, 10000], name: '6,000-10,000 lbs. (2)' },
    { id: 3, class: 3, weight: [10001, 14000], name: '10,000-14,000 lbs. (3)' },
    { id: 4, class: 4, weight: [14001, 16000], name: '14,001-16,000 lbs. (4)' },
    { id: 5, class: 5, weight: [16001, 19500], name: '16,001-19,500 lbs. (5)' },
    { id: 6, class: 6, weight: [19501, 26000], name: '19,501-26,000 lbs. (6)' },
    { id: 7, class: 7, weight: [26001, 33000], name: '26,001-33,000 lbs. (7)' },
    { id: 8, class: 8, weight: [33000, 100000], name: '> 33,000 lbs. (8)' },
];
